import { useTheme } from '../../core'
import { iconFactory } from '../iconFactory'

export interface HeartProps {
  fill?: string
  strokeColor?: string
  selected?: boolean
}

export const Heart = iconFactory(
  'Heart',
  ({ selected, strokeColor }: HeartProps) => {
    const theme = useTheme()

    return selected ? (
      <path
        d="M12.0001,5.5898 C10.9101,4.3098 9.2401,3.4998 7.5001,3.4998 C4.4201,3.4998 2.0001,5.9198 2.0001,8.9998 C2.0001,12.7798 5.4001,15.8608 10.5501,20.5398 L12.0001,21.8498 L13.4501,20.5298 C18.6001,15.8608 22.0001,12.7798 22.0001,8.9998 C22.0001,5.9198 19.5801,3.4998 16.5001,3.4998 C14.7601,3.4998 13.0901,4.3098 12.0001,5.5898 Z"
        fill={theme.colors.red['01']}
      ></path>
    ) : (
      <path
        d="M12.1001,19.0498 L12.0001,19.1508 L11.9001,19.0498 C7.1401,14.7398 4.0001,11.8898 4.0001,8.9998 C4.0001,6.9998 5.5001,5.4998 7.5001,5.4998 C9.0401,5.4998 10.5401,6.4898 11.0701,7.8598 L12.9401,7.8598 C13.4601,6.4898 14.9601,5.4998 16.5001,5.4998 C18.5001,5.4998 20.0001,6.9998 20.0001,8.9998 C20.0001,11.8898 16.8601,14.7398 12.1001,19.0498 M16.5001,3.4998 C14.7601,3.4998 13.0901,4.3098 12.0001,5.5898 C10.9101,4.3098 9.2401,3.4998 7.5001,3.4998 C4.4201,3.4998 2.0001,5.9198 2.0001,8.9998 C2.0001,12.7798 5.4001,15.8608 10.5501,20.5398 L12.0001,21.8498 L13.4501,20.5298 C18.6001,15.8608 22.0001,12.7798 22.0001,8.9998 C22.0001,5.9198 19.5801,3.4998 16.5001,3.4998"
        strokeWidth="1"
        fill={strokeColor ?? theme.colors.gray['04']}
      ></path>
    )
  },
)
